AGA.DynamicQuery = (function () {

    var saveTimeout = null;

    var clearSaveTimeout = function () {
        if (saveTimeout)
            clearTimeout(saveTimeout);
        saveTimeout = null;
    };

    var getModalConfiguration = function (configuration) {
        var defaults = {
            id: 'DynamicQueryModal',
            url: '',
            size: "large",
            displayFooter: false,
            displayTitle: false,
            // ocupar 90% da altura, menos a altura do footer do modal
            height: parseInt($(window).height() * 0.9) - 70
        };

        var result = $.extend(defaults, configuration);
        return result;
    };

    var getCurrentQueryId = function () {
        var value = AGA.Lookup.getValue("DynamicQuerySelectorMain");
        return value;
    };

    var updateFilters = function (queryId) {
        AGA.Helper.blockElement("#FiltrosBody", "Carregando filtros...");
        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetFilters?queryId=" + String(queryId) + "&_=" + new Date().getTime());

        // Update filtros
        $("#FiltrosPlaceholder").load(url, function () {
            AGA.Helper.unblockElement("#FiltrosBody");
            AGA.JavascriptButton.enable("#ModificarFiltrosButton");
            AGA.JavascriptButton.enable("#LimparFiltrosButton");
            $(".btn-generation").each(function (index, item) {
                AGA.JavascriptButton.enable(item);
            });
        });
    };

    var updateColumns = function (queryId) {
        AGA.Helper.blockElement("#ColumnsBody", "Carregando colunas...");
        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetColumns?queryId=" + String(queryId) + "&_=" + new Date().getTime());

        // Update filtros
        $("#ColumnsPlaceholder").load(url, function () {
            AGA.Helper.unblockElement("#ColumnsBody");
        });
    };

    var updateCurrent = function () {
        var current = getCurrentQueryId();
        updateFilters(current);
        updateColumns(current);
        $(".dynamic-query-output").empty()
        $(".row-message-execute").show();
    };

    var selectQueryImplementation = function (queryId, queryName) {
        AGA.Lookup.setValue("DynamicQuerySelectorMain", queryId, queryName);
    };

    var getFilterData = function () {
        var queryId = getCurrentQueryId();
        if (AGA.Helper.isNullValue(queryId))
            return null;

        var valores = AGA.Form.getValues("FormFiltros");
        var names = [];
        var values = [];        
        for (prop in valores) {
            if (valores.hasOwnProperty(prop)) {
                names.push(prop);
                values.push(valores[prop]);
            }
        }

        return {
            queryId: queryId,
            names: names,
            values: values
        };
    };

    var saveFilterData = function (data) {
        if (data) {
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveUserFilterValues");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });
        }
    };

    var saveFilterValues = function () {
        var data = getFilterData();
        saveFilterData(data);
    };

    var queryChangedImplementation = function () {
        // Limpar o timeout para garantir que o filtro antigo seja salvo
        saveTimeout = null;

        updateCurrent();
    };

    var createNewImplementation = function (e) {
        var url = $(".aga-dynamic-query-selector").data("urlCreateNew");

        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(
            modalConfig,
            Benner.Widget.openModal,
            Benner.Widget.disposeModal);
    };

    var manageImplementation = function () {
        var url = $(".aga-dynamic-query-selector").data("urlManaging");

        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(modalConfig, Benner.Widget.openModal, Benner.Widget.disposeModal);
    };


    var copyImplementation = function () {
        var url = $(".aga-dynamic-query-selector").data("urlCopy");
        var currentQueryId = getCurrentQueryId();
        url = url + "&queryId=" + String(currentQueryId);
        var modalConfig = getModalConfiguration({
            url: url
        });

        Benner.ModalPage.show(modalConfig, Benner.Widget.openModal, Benner.Widget.disposeModal);
    };

    var changeFiltersImplementation = function () {

        // Salvar filtros
        clearSaveTimeout();
        saveFilterValues();

        // Abrir modal
        var url = $(".aga-dynamic-query-selector").data("urlManageFilters");
        url += "?imp=1&queryId=" + String(getCurrentQueryId());

        var modalConfig = getModalConfiguration({
            url: url,
            displayTitle: true,
            title: "Filtros da consulta"
        });

        Benner.ModalPage.show(
            modalConfig,
            Benner.Widget.openModal,
            function () {
                Benner.Widget.disposeModal();
                updateFilters(getCurrentQueryId());
            }
        );
    };

    var clearFilterValuesImplementation = function () {
        clearSaveTimeout();
        $("#FiltrosBody").find(".aga-lookup").each(function (index, item) { AGA.Lookup.clear(item); });
        $("#FiltrosBody").find(".aga-date").each(function (index, item) { AGA.Date.clear(item); });
        $("#FiltrosBody").find(".aga-number").each(function (index, item) { AGA.Number.setValue(item, ''); });
        $("#FiltrosBody").find(".aga-radio").each(function (index, item) { AGA.Radio.clear(item); });
        $("#FiltrosBody").find(".aga-text").each(function (index, item) { AGA.Text.clear(item); });
        saveFilterValues();
    };

    var sugestEndValue = function (e) {
        if ($(e.currentTarget).hasClass("aga-date") && e.name) {
            var regex = /^([A-Z_0-9]*)_DE$/;
            var matches = regex.exec(e.name);
            if (matches && matches.length > 1) {
                var target = matches[1] + "_ATE";
                var value = e.value;

                AGA.Date.setValue(target, value);
            }
        }
    };

    var anyFilterChangeImplementation = function (e) {
        sugestEndValue(e);
        clearSaveTimeout();
        var data = getFilterData();
        saveTimeout = setTimeout(function () {
            saveTimeout = null;
            saveFilterData(data);
        }, 2000);

        $(".dynamic-query-output").empty()
        $(".row-message-execute").show();
    };

    var saveColumns = function () {
        var names = [];

        $(".dynamic-query-columns-selected .col-item-selected").each(function (index, item) {
            var name = $(item).data("name");
            if (name)
                names.push(name);
        });

        $(".dynamic-query-facts input.dynamic-query-fact:checked").each(function (index, item) {
            var name = $(item).data("name");
            if (name)
                names.push(name);
        });

        var data = {
            queryId: getCurrentQueryId(),
            names: names
        };

        if (data) {
            var url = AGA.Ajax.getUrlPath("DynamicQuery/SaveSelectedColumns");
            $.ajax({
                url: url,
                method: "POST",
                data: data
            });
        }
    };

    var handleSelectedItemMoveUp = function (e) {
        var liSource = $(e.currentTarget).closest("li");
        var prev = $(liSource).prev();
        if (prev && !$(prev).hasClass("item-selected-pattern")) {
            $(liSource).insertBefore(prev);
        }
        saveColumns();
    };

    var handleSelectedItemMoveDown = function (e) {
        var liSource = $(e.currentTarget).closest("li");
        var next = $(liSource).next();
        if (next) {
            $(liSource).insertAfter(next);
        }
        saveColumns();
    };

    var handleItemUnselect = function (e) {
        var liSource = $(e.currentTarget).closest("li");
        var dataName = $(liSource).data("name");
        $(liSource).detach();

        $(".dynamic-query-columns > [data-name=" + dataName + "]").removeClass("column-is-selected");
        saveColumns();
    };

    var handleItemSelect = function (e) {
        var liSource = $(e.currentTarget).closest("li");

        // Remover item
        $(liSource).addClass("column-is-selected");

        // Adicionar lista selecionados  
        var pattern = $(".item-selected-pattern").get(0);
        var item = pattern.cloneNode(true);

        $(item)
            .data("name", liSource.data("name"))
            .removeClass("hide item-selected-pattern")
            .append(liSource.data("fullDisplay"));

        $(".dynamic-query-columns-selected").append(item);
        saveColumns();
    };

    var handleSearchBar = function () {
        var texto = $(".dynamic-query-search").val();

        var itens = $(".col-item-selectable");

        if (texto.length > 0) {
            var exp = new RegExp(texto, 'i');
            for (var i = 0; i < itens.length; i++) {
                var coluna = itens[i];

                var nomeCampo = coluna.dataset.fullDisplay;

                if (!exp.test(nomeCampo)) {
                    coluna.classList.add('hidden');
                } else {
                    coluna.classList.remove('hidden');
                }
            }
        } else {
            for (var i = 0; i < itens.length; i++) {
                var coluna = itens[i];
                coluna.classList.remove('hidden');
            }
        }
    };

    var handleDynamicQueryFact = function () {
        saveColumns();
    };

    var handlePortletClick = function (e) {
        $(e.currentTarget).closest(".portlet-title").find(".tools > a.collapse, .tools > a.expand").click();
    };

    var generateImplementation = function (format) {
        var data = getFilterData();
        data.format = format;      
        data.breaks = document.getElementById("QuantidadeQuebras").value;
        if (data.breaks === "") {
            data.breaks = 0;
        }

        var url = AGA.Ajax.getUrlPath("DynamicQuery/Generate");
        AGA.Helper.blockUI();
        $(".row-message-execute").hide();
        $(".dynamic-query-output").empty()

        try {
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                },
                fail: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                }
            });
        }
        catch{
            AGA.Helper.unblockUI();
        }
    };


    var navigateGridImplementation = function (index, count) {
        var data = getFilterData();
        data.StartIndex = index;
        data.Count = count;

        var url = AGA.Ajax.getUrlPath("DynamicQuery/GetGrid");
        AGA.Helper.blockUI();

        try {
            $.ajax({
                url: url,
                method: "POST",
                data: data,
                success: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").html(data);
                },
                fail: function (data) {
                    AGA.Helper.unblockUI();
                    $(".dynamic-query-output").append(data);
                }
            });
        }
        catch{
            AGA.Helper.unblockUI();
        }
    };

    var inited = false;
    var initImplementation = function () {
        if (inited) return;
        inited = true;

        $("body").on("click", ".dynamic-query-moveup", handleSelectedItemMoveUp);
        $("body").on("click", ".dynamic-query-movedown", handleSelectedItemMoveDown);
        $("body").on("click", ".dynamic-query-unselect", handleItemUnselect);
        $("body").on("click", ".dynamic-query-select", handleItemSelect);
        $("body").on("input", ".dynamic-query-search", handleSearchBar);
        $("body").on("click", ".dynamic-query-fact", handleDynamicQueryFact);
        $("body").on("click", ".dynamic-query-portlet > .portlet-title > .caption", handlePortletClick);
    };

    var _events = [];
    var addEventListenerImplementation = function (eventName, callback) {
        _events.push({ eventName: eventName, callback: callback });
    };

    var dispatchEventImplementation = function (eventName, data) {
        for (var i = 0; i < _events.length; i++) {
            if (_events[i].eventName === eventName) {
                _events[i].callback(data);
            }
        }
    };

    return {
        init: initImplementation,
        selectQuery: selectQueryImplementation,
        queryChanged: queryChangedImplementation,
        createNew: createNewImplementation,
        manage: manageImplementation,
        copy: copyImplementation,
        changeFilters: changeFiltersImplementation,
        clearFilterValues: clearFilterValuesImplementation,
        anyFilterChange: anyFilterChangeImplementation,
        generate: generateImplementation,
        navigateGrid: navigateGridImplementation,
        addEventListener: addEventListenerImplementation,
        dispatchEvent: dispatchEventImplementation
    };
})();

$(document).ready(function () {
    AGA.DynamicQuery.init();
});